import * as API from "../../api";
import * as ActionTypes from "../action-types";
import { message } from "antd";

export const get_all_loyalty_request = () => (dispatch) => {
  API.getAllLoyalty()
    .then((info) => {
      const { status, msg, loyalties } = info;
      if (status === 200) {
        dispatch(get_all_loyalty_success(loyalties));
        message.success("Successfully got all the loyalty data");
      } else {
        message.warning(msg);
      }
    })
};

const get_all_loyalty_success = (loyalties) => {
  return {
    type: ActionTypes.LOYALTY_GET_ALL,
    loyalties,
  };
};